import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import * as moment from 'moment';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from 'src/app/services/admin/admin.service';
import { VoucherListComponent } from '../voucher-list/voucher-list.component';
import { DatePipe } from '@angular/common';
import { MessagesService } from 'src/app/services/message/messages.service';
import { EventsService } from 'src/app/services/events/events.service';
import { voucherStatus, voucherCategory, subscriptionType ,planType,accountType,duration } from '../../data-tables';

@Component({
  selector: 'app-voucher-create',
  templateUrl: './voucher-create.component.html',
  styleUrls: ['./voucher-create.component.less'],
  providers: [DatePipe]
})
export class VoucherCreateComponent implements OnInit {
  private voucherForm: FormGroup;
  private allVoucherStatus = voucherStatus;
  private allVoucherCategory = voucherCategory;
  private allSubscriptionType = subscriptionType;
  private allPlanType =  planType;
  private allAccountType = accountType;
  private allduration = duration;
  public accountType: any;
  public planType: any;

  constructor(private fb: FormBuilder, private active: NgbActiveModal, private admin: AdminService, private modal: NgbModal,
    private datePipe: DatePipe, private msg: MessagesService, private events: EventsService) { }

  ngOnInit() {
    this.init();
  }

  private init() {
    this.voucherForm = this.fb.group({
      'type': ['iot', [Validators.required]],
      'name': [null, []],
      'training': ['false', []],
      'dateCreated': [moment(), [Validators.required]],
      'dateExpiration': [moment(), [Validators.required]],
      'discount': [10, [Validators.required]],
      'count': [1, [Validators.required]],
      'duration':[1,[Validators.required]],
      'planType':['beginner_yearly_1',[Validators.required]],
      'generateNum': [1, [Validators.required]],
      'status': ['draft', [Validators.required]],
      'category': ['individual', [Validators.required]],
      'accountType':['beginner', [Validators.required]],
      'subscriptionType':['yearly',[Validators.required]]
    });
    this.accountType = 'beginner'
    const todaysDate = this.datePipe.transform(moment(), 'yyyy-MM-dd');

    this.voucherForm.get('dateCreated').setValue(todaysDate);
    this.voucherForm.get('dateExpiration').setValue(todaysDate);
  }

  public getForm() {
    return this.voucherForm;
  }

  public getItem(item) {
    if (item === 'status') {
      return this.allVoucherStatus.filter(filter => filter !== 'ended');
    }

    if (item === 'category') {
      return this.allVoucherCategory;
    }

    if(item === 'planType'){
      let plans = this.allPlanType[this.accountType]
      return plans;
    }
    if(item === 'subscriptionType'){
      return this.allSubscriptionType
    }
    if(item === 'accountType'){
       return this.allAccountType;
    }
    if(item === 'duration'){
      return this.allduration;
    }

    return null;
  }

  public async createVoucher() {
    // get voucher details
    const name = this.voucherForm.value.name;
    const type = this.voucherForm.value.type;
    const status = this.voucherForm.value.status;
    const category = this.voucherForm.value.category;
    const dateCreate = new Date(this.voucherForm.value.dateCreated).toISOString();
    const dateExp = new Date(this.voucherForm.value.dateExpiration).toISOString();
    const discount = this.voucherForm.value.discount;
    const count = this.voucherForm.value.count;
    const plan_type = this.voucherForm.value.planType.toString();
    const description = {};
    
    description['account_type'] = this.voucherForm.value.accountType.toString();
   // description['duration'] = this.voucherForm.value.duration.toString();
    description['isTraining'] = this.voucherForm.value.training.toString();
    description['totalCount'] = count;
    let howManyVouchers = this.voucherForm.value.generateNum;


    description['plan_type'] = plan_type;
    // check if discount value is more than 100
    // if yes stop
    if (discount > 100) {
      this.msg.warn('Discount cannot be more than 100');

      return;
    }

    if (moment(dateCreate) > moment(dateExp)) {
      this.msg.warn('Date Start cannot be greator than Date Expires');
      return;
    }

    // voucher object
    const voucherObj = {
      voucher_code: name,
      voucher_type: type,
      date_created: dateCreate,
      date_expired: dateExp,
      discount: discount.toString(),
      count: Number(count),
      description: JSON.stringify(description),
      status: status,
      category: category
    };

    // console.log(voucherObj);

    const arrayOfVouchers = [];
   
    while (howManyVouchers > 0) {
      let voucher;
      try {
        voucher = await (this.admin.submitNewVoucher(voucherObj as any));
        voucher = voucher.results;

        // format it - with previous voucher obj and server voucher obj
        const descObj = JSON.parse(voucherObj.description);

        const finalVoucherObj = {
          type: voucherObj.voucher_type,
          code: voucherObj.voucher_code === null ? voucher.voucher_code : voucherObj.voucher_code,
          discount: voucherObj.discount,
          expires: voucherObj.date_expired,
          isTraining: descObj.isTraining,
          extendYears: descObj.extendYear,
          count: voucherObj.count,
          status: voucherObj.status,
          category: voucherObj.category
        };

        arrayOfVouchers.push(finalVoucherObj);

        howManyVouchers -= 1;
      } catch (e) {
        console.log(e);
        throw e;
      }
    }

    if (arrayOfVouchers.length >= 1) {
      const modal = this.modal.open(VoucherListComponent, {
        size: 'lg'
      });

      modal.componentInstance.allVouchers = arrayOfVouchers;

      this.events.triggerTableReload('', 'create', 'create', null);

      this.msg.success('Successfully created voucher(s)');
    }

  }

  public closeModal() {
    this.active.close();
  }

  public updateAccountType(acctype){
      this.accountType = acctype;
  }

  public checkPlanType(plan){
    this.planType = plan;
  }
}
